export default __webpack_public_path__ + "static/es-36cdd00d34fa3ab9d98aba66d3ac5b39.svg";